/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-constant-condition */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import {
  faArrowRight,
  faCheck,
  faCheckCircle,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory, useLocation } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import Lottie from 'react-lottie'
import { isAfter } from 'date-fns'
import downloadLottie from '../../assets/icons/arquivo-baixado.json'
import copyLottie from '../../assets/icons/copiar-codigo.json'
import iconInfoGreen from '../../assets/icons/information.svg'
import iconDownload from '../../assets/icons/download.svg'
import noInvoicesPendIcon from '../../assets/icons/noinvoices.svg'
import searchIcon from '../../assets/icons/searchIcon.svg'
import * as S from './styles'
import { newApi } from '../../services/api'
import loadingIcon from '../../assets/icons/loading.svg'

import loadingPrimaryIcon from '../../assets/icons/loading-primary.svg'
import keyboardDownIcon from '../../assets/icons/keyboardDownIcon.svg'
import {
  FaturaDTO,
  Invoice as InvoiceValue,
  StateInitial,
  TFInvoice,
  User,
} from '../../utils/models'
import { PaymentSlip } from '../../components/PDF'
import { isAuthenticated } from '../../utils/auth'
import Footer from '../../components/Footer'
import visibilityIcon from '../../assets/icons/visibility_icon.svg'
import emptyInvoiceIcon from '../../assets/icons/emptyInvoice.svg'
import logoBill from '../../assets/images/logo-bill.png'
import { InvoiceItem } from './components/InvoiceItem'
import { InvoiceDetailModal } from './components/InvoiceDetailModal'
import {
  defaultPageSize,
  handleConsultDoc,
  handleUC,
  pageSizes,
} from './viewModel'
import { PaginationFooterV2WithoutTotal } from '../../components/PaginationFooterWithoutTotal'
import Select from '../../components/Select'
import { FormlessSelect } from '../../components/FormlessSelect'
import { removeDuplicates } from '../../utils/removeDups'
import { PaginationFooterV2WithTotal } from '../../components/PaginationFooterWithTotal'

const DECIMAL_NUMBER = 10
const THREE_SECONDS = 3000

interface DataDashDTO {
  modules: StateInitial
  dispatch: any
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Home = ({ modules, dispatch }: DataDashDTO): any => {
  const location = useLocation<any>()
  const [pageSize, setPageSize] = useState(defaultPageSize)
  const [total, setTotal] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [allInvoices, setAllInvoices] = useState<Array<TFInvoice>>([])
  const [invoices, setInvoices] = useState<Array<TFInvoice>>()
  const [yearsInvoices, setYears] = useState<Array<number>>([])
  const [invoicesId, setInvoicesId] = useState<number[]>()
  const [loadingData, setLoadingData] = useState(true)
  const [donwloadIdInvoice, setIdInvoice] = useState<string>()
  const [showDetails, setShowDetails] = useState<string>()
  const history = useHistory()
  const [totalCart, setTotalCart] = useState(0)
  const [originalValue, setOriginalValue] = useState(0)
  const [penalty, setPenalty] = useState(0)
  const [fees, setFees] = useState(0)
  const [correction, setCorrection] = useState(0)
  const [loading, setLoading] = useState(false)
  const [showInfo, setShowInfo] = useState<number | null>()
  const [markAll, setMarkAll] = useState(false)
  const [downloadThis, setDownloadThis] = useState<TFInvoice>()
  const [selectedInvoice, setSelectedInvoice] = useState<TFInvoice>()
  const [filterStatus, setFilterStatus] = useState('TODOS')
  const [showInfoDownloadFile, setShowInfoDownloadFile] = useState<boolean>(
    false
  )
  const [filterText, setFilterText] = useState('')
  const [page, setPage] = useState(1)
  function checkDueStatus(invoiceInfo: TFInvoice): boolean {
    const { paymentStatus } = invoiceInfo

    if (!paymentStatus) {
      return true
    }

    return false
  }

  function checkDueDate(dataInvoice: string): boolean {
    const [year, month, day] = dataInvoice.split('-')
    // console.log(dataInvoice)
    const dateInvoice = new Date(
      parseInt(year, DECIMAL_NUMBER),
      parseInt(month, DECIMAL_NUMBER) - 1,
      parseInt(day, DECIMAL_NUMBER)
    )
    dateInvoice.setHours(23, 59, 59)
    // VERIFICAÇÃO DE VENCIMENTO, REMOVENDO TEMPORARIAMENTE PARA TESTES
    return true
    return isAfter(dateInvoice, new Date())
  }

  const filteredInvoices = invoices?.filter((invoice) => {
    return !filterText || `${invoice.id}`.includes(filterText)
  })

  /* function showModalWhenDocEmpty(module: User, loadingSearchBd: boolean): unknown {
    return {
        type: 'SET_VISIBILITY_MODAL',
        module,
        loadingSearchBd,
    };
  } */

  function setLoadingSearchDb(
    module: boolean,
    showLoadingDb: boolean
  ): unknown {
    return {
      type: 'SET_SEARCH_DB_LOADING',
      module,
      showLoadingDb,
    }
  }

  useEffect(() => {
    if (invoices) {
      if (invoicesId) {
        const filterableInvoices = invoices.filter((invPend) => {
          if (invPend.paymentDueDate) {
            const isDueDate = checkDueDate(invPend.paymentDueDate)
            if (!isDueDate) {
              return false
            }
          }
          const isDueStatus = checkDueStatus(invPend)
          if (!isDueStatus) {
            return false
          }
          return true
        })
        if (
          filterableInvoices.length === 0 ||
          invoicesId.length < filterableInvoices.length
        ) {
          setMarkAll(false)
        } else {
          setMarkAll(true)
        }
      }
    }
  }, [invoices, invoicesId])

  useEffect(() => {
    if (isAuthenticated()) {
      const temp = localStorage.getItem('Invoices')
      if (temp) {
        const tempInvoices = JSON.parse(temp)
        if (tempInvoices[0] && tempInvoices[0].id) {
          const limitedInvoices = [...tempInvoices].slice(0, 10)
          setInvoices(limitedInvoices)
          if (limitedInvoices.length < ( pageSize)) {
            setHasMore(false)
          } else {
            setHasMore(true)
          }

          setAllInvoices(tempInvoices)
          // console.log('12345')
          setLoadingData(false)
        } else {
          setYears([])
          setLoadingData(false)
        }
      } else {
        setYears([])
        setLoadingData(true)
      }
      const tempTotal = localStorage.getItem('x-total')
      if (tempTotal) {
        setTotal(Number(tempTotal) || 0)
      }
    } else {
      history.push('/login')
    }
  }, [modules])

  useEffect(() => {
    if (allInvoices && allInvoices.length) {
      const data = []
      data.push(parseFloat(allInvoices[0].refDate.substr(3)))
      for (let i = 1; i < allInvoices.length; i += 1) {
        if (
          parseFloat(allInvoices[i].refDate.substr(3)) !==
          parseFloat(allInvoices[i - 1].refDate.substr(3))
        ) {
          data.push(parseFloat(allInvoices[i].refDate.substr(3)))
        }
      }
      setYears(data)
    }
  }, [allInvoices])

  useEffect(() => {
    if (location.state) {
      if (location.state.data) {
        const tempId = location.state.data.map((fatura: FaturaDTO) => {
          return fatura.id
        })
        let cartTotalTemp = 0
        let originalTemp = 0
        let penaltyTemp = 0
        let feesTemp = 0
        let correctionTemp = 0
        location.state.data.forEach((fatura: FaturaDTO) => {
          penaltyTemp += fatura.multa
          feesTemp += fatura.juros
          correctionTemp += fatura.correcao
          cartTotalTemp += fatura.total
          originalTemp += fatura.fatura
        })
        setPenalty(penaltyTemp)
        setFees(feesTemp)
        setCorrection(correctionTemp)
        setOriginalValue(originalTemp)
        setTotalCart(cartTotalTemp)
        setInvoicesId(tempId)
      }

      if (location.state.refreshRef) {
        getFromRef(location.state.refreshRef, 1)
      } else if (location.state.docField) {
        getFromDoc(location.state.docField, 1)
      }
    }
  }, [
    location,
    // allInvoices
  ])

  function checkAllInvoices(checkbox: boolean): void {
    if (checkbox) {
      setTotalCart(0)
      setOriginalValue(0)
      let totalCartTemp = 0
      let originalValueTemp = 0
      setInvoicesId([])
      const invoiceTemp = [] as number[]
      if (invoices) {
        invoices.forEach((invPend) => {
          if (invPend.paymentDueDate) {
            const isDueDate = checkDueDate(invPend.paymentDueDate)
            if (!isDueDate) {
              return
            }
          }
          const isDueStatus = checkDueStatus(invPend)
          if (!isDueStatus) {
            return
          }

          totalCartTemp += invPend.totalPaymentDue as number
          originalValueTemp += invPend.totalPaymentDue as number
          if (invPend.invoice_id) {
            invoiceTemp.push(invPend.invoice_id)
          }
        })
      }

      setTotalCart(totalCartTemp)
      setOriginalValue(originalValueTemp)

      setInvoicesId(invoiceTemp)
    } else {
      setTotalCart(0)
      setOriginalValue(0)
      setInvoicesId([])
    }
  }

  function invoiceDescription(invoice: TFInvoice): string {
    if (invoice.extras.custa) {
      if (invoice.extras.custa[0]) {
        return `${
          invoice.extras.parcela ? `${invoice.extras.parcela} • ` : ''
        }${invoice.extras.custa[0].descricao}`
      }
    }
    if (invoice?.extras?.description) {
      return `${invoice.extras.parcela ? `${invoice.extras.parcela} • ` : ''}${
        invoice.extras?.description
      }`
    }
    if (invoice?.description) {
      return `${invoice.extras.parcela ? `${invoice.extras.parcela} • ` : ''}${
        invoice.description
      }`
    }

    return '-'
  }

  function handlePaymentButton(invoice: TFInvoice): void {
    if (invoice && invoice.paymentDueDate) {
      if (!checkDueDate(invoice.paymentDueDate)) {
        return
      }
    }
    const isDueStatus = checkDueStatus(invoice)
    if (!isDueStatus) {
      return
    }

    const resp = invoicesId?.filter((inv) => {
      return inv !== invoice.invoice_id
    })
    if (resp) {
      if (resp?.length === invoicesId?.length) {
        setTotalCart(totalCart + (invoice.totalPaymentDue as number))
        setOriginalValue(originalValue + (invoice.totalPaymentDue as number))

        if (invoice.invoice_id)
          setInvoicesId([...invoicesId, invoice.invoice_id])
      } else {
        if (totalCart - (invoice.totalPaymentDue as number) <= 1) {
          setPenalty(0)
          setFees(0)
          setCorrection(0)
          setOriginalValue(0)
          setTotalCart(0)
        } else {
          setOriginalValue(originalValue - (invoice.totalPaymentDue as number))
          setTotalCart(totalCart - (invoice.totalPaymentDue as number))
        }
        setInvoicesId(resp)
      }
    } else {
      setTotalCart(invoice.totalPaymentDue as number)
      setOriginalValue(invoice.totalPaymentDue as number)
      if (invoice.invoice_id) setInvoicesId([invoice.invoice_id])
    }
  }

  function checkIdList(invoiceIdparse: number | null): boolean {
    if (invoiceIdparse) {
      const resp = invoicesId?.filter((invoice) => {
        return invoice === invoiceIdparse
      })
      if (resp)
        if (resp?.length > 0) {
          return true
        }
    }
    return false
  }

  function generatingTextStatus(inv: TFInvoice): string {
    if (inv.paymentDueDate) {
      if (!checkDueDate(inv.paymentDueDate)) {
        return 'Vencida'
      }
    }
    if (inv.paymentStatus === null) return 'Aberta'
    if (inv.paymentStatus === 1) return 'Paga'
    if (inv.paymentStatus === -1) return 'Indisponível'
    if (inv.paymentStatus === 0) return 'Aberta'

    return 'Aberto'
  }

  function generatingColorStatus(inv: TFInvoice): string {
    if (inv.paymentDueDate) {
      if (!checkDueDate(inv.paymentDueDate)) {
        return '#D93B3C'
      }
    }

    return getColorSituation(inv)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function getColorSituation(situation: TFInvoice): string {
    if (situation.paymentStatus === -1) return '#9E9E9E'
    if (situation.paymentStatus === 1) return '#00AB50'
    if (situation.paymentStatus === 0) return '#F79E1B'
    return '#F79E1B'
  }

  function getSituation(situation: TFInvoice): number {
    if (situation.paymentStatus) {
      return 1
    }
    return 0
  }

  async function paymentHandle(): Promise<void> {
    // console.log(invoicesId);

    // return;

    setLoading(true)
    const token = sessionStorage.getItem('token')
    const temp = localStorage.getItem('Invoices')
    let client
    if (temp && token) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      client = JSON.parse(temp || '')

      const invoicesList: any = []

      invoicesId?.forEach((ii) => {
        invoicesList.push({ id: ii })
      })

      try {
        if (invoices) {
          const { data } = await newApi.post(
            '/mobile/payment',
            {
              merchant: process.env.REACT_APP_MERCHANT_FIXED,
              doc: '',
              invoices: invoicesList,
            },
            {
              headers: {
                Authorization: `Basic ${token}`,
                'Content-Type': 'application/json',
              },
            }
          )

          if (data) {
            //  console.log(data)
            setLoading(false)
            history.push({
              pathname: '/payment',
              state: {
                data,
              },
            })
          }
        }
      } catch (error) {
        // console.log(error)
      } finally {
        setLoading(false)
      }
    }
  }

  function downloadPdf(invoice: TFInvoice): void {
    setShowInfoDownloadFile(true)
    setTimeout(() => {
      setDownloadThis(invoice)
      setShowInfoDownloadFile(false)
    }, THREE_SECONDS)
    setDownloadThis(undefined)
    if (donwloadIdInvoice === invoice.id) {
      setIdInvoice(undefined)
    } else {
      setIdInvoice(invoice.id)
    }
  }

  function transformDate(d: string): string {
    const dSplit = d.split('-')

    return `${dSplit[2]}/${dSplit[1]}/${dSplit[0]}`

    return ''
  }

  const markedInvoices = allInvoices?.filter((invoiceItem) =>
    invoicesId?.includes(invoiceItem.invoice_id)
  )

  async function getPaymentMethods(): Promise<any> {
    try {
      const token = sessionStorage.getItem('token')
      const { data } = await newApi.get(
        `/mobile/payment/payment-methods?merchant=${process.env.REACT_APP_MERCHANT_FIXED}`,
        {
          headers: {
            Authorization: `Basic ${token}`,
            'X-Forwarded-Host':
              window.location.hostname || process.env.REACT_APP_HOST,
          },
        }
      )
      localStorage.setItem(
        'payment_methods',
        JSON.stringify(data.payment_methods)
      )
      return data.payment_methods
    } catch (error) {
      console.log(error)
    }
    return undefined
  }
  useEffect(() => {
    getPaymentMethods()
  }, [])

  function changePage(nextPage: boolean): void {
    let nextPageValue = page
    if (nextPage) {
      nextPageValue += 1
    } else {
      nextPageValue -= 1
    }
    setPage(nextPageValue)
    const refreshRef = localStorage.getItem('refreshRef')
    if (refreshRef && refreshRef.length) {
      getFromRef(refreshRef, nextPageValue)
    } else {
      const docField = localStorage.getItem('refreshDoc')
      if (docField && docField.length) {
        getFromDoc(docField, nextPageValue)
      }
    }
  }

  function changeMaxPage(maxPage: number): void {
    setPageSize(maxPage)
    const refreshRef = localStorage.getItem('refreshRef')
    if (refreshRef && refreshRef.length) {
      setPage(1)
      getFromRef(refreshRef, 1, maxPage)
    } else {
      const docField = localStorage.getItem('refreshDoc')
      if (docField && docField.length) {
        setPage(1)
        getFromDoc(docField, 1, maxPage)
      }
    }
  }

  async function getFromRef(
    refreshRef: string,
    nextPageValue: number,
    localPageSize?: number
  ): Promise<void> {
    setLoadingData(true)
    try {
      const data = await handleUC(
        refreshRef,
        nextPageValue,
        localPageSize || pageSize
      )
      if (data.invoices && data.invoices.length > 0) {
        const temp = [...allInvoices, ...data.invoices]
        const removedDups = removeDuplicates(temp)
        localStorage.setItem('Invoices', JSON.stringify(removedDups))
        localStorage.setItem('refreshRef', refreshRef)
        setInvoices(data.invoices)
        setAllInvoices(removedDups)
        if (data.invoices.length < (localPageSize || pageSize)) {
          setHasMore(false)
        } else {
          setHasMore(true)
        }
      }
      setTotal(data.total || 0)
    } catch (error) {
      console.log(error)
      setHasMore(false)
    } finally {
      setLoadingData(false)
    }
  }

  async function getFromDoc(
    docField: string,
    nextPageValue: number,
    localPageSize?: number
  ): Promise<void> {
    setLoadingData(true)
    try {
      const data = await handleConsultDoc(
        docField,
        nextPageValue,
        localPageSize || pageSize
      )
      if (data.invoices && data.invoices.length > 0) {
        localStorage.setItem('refreshDoc', docField)

        const temp = [...allInvoices, ...data.invoices]
        const removedDups = removeDuplicates(temp)
        localStorage.setItem('Invoices', JSON.stringify(removedDups))

        setInvoices(data.invoices)
        setAllInvoices(removedDups)
        if (data.invoices.length < (localPageSize || pageSize)) {
          setHasMore(false)
        } else {
          setHasMore(true)
        }
      }
      setTotal(data.total || 0)
    } catch (error) {
      console.log(error)
      setHasMore(false)
    } finally {
      setLoadingData(false)
    }
  }

  return (
    <S.Container>
      <div style={{ display: 'none', opacity: 0 }}>
        {downloadThis && (
          <PaymentSlip idInvoice={donwloadIdInvoice} invoice={downloadThis} />
        )}
      </div>
      {selectedInvoice ? (
        <InvoiceDetailModal
          invoiceItem={selectedInvoice}
          generatingColorStatus={generatingColorStatus}
          generatingTextStatus={generatingTextStatus}
          invoiceDescription={invoiceDescription}
          closeModal={() => {
            setSelectedInvoice(undefined)
          }}
        />
      ) : null}
      <S.Box>
        <S.BoxInfoDownload
          style={{
            opacity: !showInfoDownloadFile ? 0 : 1,
            bottom: !showInfoDownloadFile ? 0 : 40,
            transition: '0.5s ease',
            padding: 0,
            display: 'none',
          }}
        >
          <Lottie
            style={{ width: 20, height: 20, margin: 0, padding: 0 }}
            options={{
              autoplay: true,
              loop: true,
              animationData: downloadLottie,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
            isStopped={!showInfoDownloadFile}
            height={20}
            width={20}
          />
          <span>Salvando Fatura</span>
        </S.BoxInfoDownload>
        <S.BoxInfoCopy
          style={{
            opacity: !showInfo ? 0 : 1,
            bottom: !showInfo ? 0 : 40,
            transition: 'all 0.5s ease',
            padding: 0,
            display: 'none',
          }}
        >
          <Lottie
            style={{
              width: 20,
              height: 20,
              margin: '0px 0px 0px 0px',
              padding: 0,
            }}
            options={{
              autoplay: true,
              loop: true,
              animationData: copyLottie,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
            isStopped={!showInfo}
            height={20}
            width={20}
          />
          <span>Código de barras copiado</span>
        </S.BoxInfoCopy>
        <S.Left>
          <div
            className="leftHeader"
            style={{ display: 'flex', flexDirection: 'row' }}
          >
            <S.Title>Débitos</S.Title>
            <S.InputSearchContainer>
              <img alt="search" src={searchIcon} />
              <input
                placeholder="Número da guia"
                value={filterText}
                type="tel"
                onChange={(e) => {
                  setFilterText(e.target.value || '')
                }}
              />
            </S.InputSearchContainer>
          </div>

          <S.TableHeader className="grid_container_row">
            <div className="grid_container_center">
              <input
                className="grid_check"
                type="checkbox"
                id="checkBox"
                checked={markAll}
                onClick={() => {
                  checkAllInvoices(!markAll)
                }}
              />
            </div>
            <p>GUIA</p>
            <p>VENCIMENTO</p>
            <p>DESCRIÇÃO</p>
            <div className="grid_container_center grid_container_end">
              <p>VALOR (R$)</p>
            </div>
            <p>SITUAÇÃO</p>
            <div />
          </S.TableHeader>

          {!loadingData ? (
            invoices && invoices.length > 0 ? (
              filteredInvoices && filteredInvoices.length ? (
                <S.BoxInvoicesPending
                  style={{
                    // marginBottom: totalCart <= 0 ? 0 : 70,
                    transition: '0.3s',
                  }}
                >
                  {filteredInvoices?.map((invoiceItem) => {
                    return (
                      <InvoiceItem
                        checkDueDate={checkDueDate}
                        checkDueStatus={checkDueStatus}
                        checkIdList={checkIdList}
                        generatingColorStatus={generatingColorStatus}
                        generatingTextStatus={generatingTextStatus}
                        handlePaymentButton={handlePaymentButton}
                        invoiceDescription={invoiceDescription}
                        invoiceItem={invoiceItem}
                      />
                    )
                  })}
                  {invoices?.map((invoiceItem) => {
                    if (true) {
                      return (
                        <div
                          className="InvoiceItem"
                          key={invoiceItem.id}
                          style={{
                            display: 'none',
                            overflow: 'hidden',
                            /* height: 145, */ borderRadius: 8,
                            backgroundColor: !(
                              showInfoDownloadFile &&
                              donwloadIdInvoice === invoiceItem.id
                            )
                              ? '#fff'
                              : 'var(--secondaryColor)',
                            position: 'relative',
                            maxWidth: 283,
                            maxHeight: 160,
                            top: 0,
                            height: 145,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            width:
                              showInfoDownloadFile &&
                              donwloadIdInvoice === invoiceItem.id
                                ? 283
                                : undefined,
                            // display:
                            //   showInfoDownloadFile &&
                            //   donwloadIdInvoice === invoiceItem.id
                            //     ? 'flex'
                            //     : undefined,
                            alignItems:
                              showInfoDownloadFile &&
                              donwloadIdInvoice === invoiceItem.id
                                ? 'center'
                                : undefined,
                            transition: '0.5',
                          }}
                        >
                          <S.BoxInvoiceRight
                            id="invoiceBox"
                            style={{
                              top: 0,
                              transition: '0.5s',
                              display:
                                showInfoDownloadFile &&
                                donwloadIdInvoice === invoiceItem.id
                                  ? 'none'
                                  : 'block',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: 'row',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                }}
                              >
                                <span>{`Fatura ${invoiceItem.refDate}`}</span>
                                <div
                                  data-tip
                                  data-for={`infoSituationInvoices${invoiceItem.id}`}
                                  style={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: 20,
                                    background: generatingColorStatus(
                                      invoiceItem
                                    ),
                                    marginLeft: 10,
                                  }}
                                />
                                <ReactTooltip
                                  id={`infoSituationInvoices${invoiceItem.id}`}
                                  place="top"
                                  type="dark"
                                  effect="solid"
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 5,
                                      alignItems: 'flex-start',
                                    }}
                                  >
                                    {generatingTextStatus(invoiceItem)}
                                  </div>
                                </ReactTooltip>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                }}
                              >
                                {/* (getSituation(invoiceItem) === 2 || getSituation(invoiceItem) === 6) && (
                                  <button data-tip data-for="buttonTextCopy" type='button' onClick={()=>{copyBarCode(invoiceItem)}}>
                                    <img src={iconBarCode} alt="Código de barras" />
                                    <ReactTooltip id='buttonTextCopy' place="top" type="dark" effect="solid">
                                      <div style={{display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'flex-start'}}>
                                        <h4>
                                          COPIAR CÓDIGO
                                        </h4>
                                      </div>
                                    </ReactTooltip>
                                  </button>
                                ) */}
                                <div>
                                  <button
                                    data-tip
                                    data-for="buttonTextDownload"
                                    type="button"
                                    onClick={() => {
                                      downloadPdf(invoiceItem)
                                    }}
                                  >
                                    {!(
                                      showInfoDownloadFile &&
                                      donwloadIdInvoice === invoiceItem.id
                                    ) ? (
                                      <img
                                        src={iconDownload}
                                        alt="Download Fatura"
                                        style={{ color: 'red' }}
                                      />
                                    ) : (
                                      'carregando'
                                    )}
                                    <ReactTooltip
                                      id="buttonTextDownload"
                                      place="top"
                                      type="dark"
                                      effect="solid"
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: 5,
                                          alignItems: 'flex-start',
                                        }}
                                      >
                                        <h4>BAIXAR VIA PARA PAGAMENTO</h4>
                                      </div>
                                    </ReactTooltip>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <span className="nameClient">
                              {invoiceItem.customer}
                            </span>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <span className="valueAndDate">
                                {`R$ ${invoiceItem.totalPaymentDue?.toLocaleString(
                                  'pt-BR',
                                  { minimumFractionDigits: 2 }
                                )}`}
                              </span>
                              <span className="valueAndDate">
                                {`VENC. ${
                                  /* invoiceItem.DT_VENCIMENTO_EDT */ invoiceItem.paymentDueDate
                                    ? transformDate(invoiceItem.paymentDueDate)
                                    : ''
                                }`}
                              </span>
                            </div>
                            {
                              /* getSituation(invoiceItem) === 0 ?
                            (
                              <div
                                data-tip
                                data-for='buttonDontPaymentOnline'
                              >
                                <button
                                  disabled
                                  type="button"
                                  className="btnOpen"
                                >
                                  EM ABERTO
                                </button>
                                <ReactTooltip id='buttonDontPaymentOnline' place="top" type="dark" effect="solid">
                                  <div style={{display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'flex-start', zIndex: 20}}>
                                    <h4>
                                      FATURA NÃO ELEGÍVEL PARA PAGAMENTO ONLINE NO CARTÃO DE CRÉDITO
                                    </h4>
                                  </div>
                                </ReactTooltip>
                              </div>
                              )
                              : */ getSituation(
                                invoiceItem
                              ) === 0 ? (
                                <button
                                  style={{
                                    background: checkIdList(
                                      invoiceItem.invoice_id
                                    )
                                      ? 'var(--secondaryColor)'
                                      : '#EDF1F5',
                                    color: checkIdList(invoiceItem.invoice_id)
                                      ? '#FFF'
                                      : 'var(--secondaryColor)',
                                    marginTop: 5,
                                    transition: 'all .5s ease',
                                  }}
                                  type="button"
                                  onClick={() => {
                                    handlePaymentButton(invoiceItem)
                                  }}
                                  className="btnConfirm"
                                >
                                  {checkIdList(invoiceItem.invoice_id) ? (
                                    <div>
                                      <FontAwesomeIcon
                                        icon={faCheckCircle}
                                        style={{ marginRight: 10 }}
                                      />
                                      FATURA SELECIONADA
                                    </div>
                                  ) : (
                                    'SELECIONAR FATURA'
                                  )}
                                </button>
                              ) : null
                            }
                          </S.BoxInvoiceRight>
                          <div
                            style={{
                              // display: getSituation(invoiceItem) !== 2 && getSituation(invoiceItem) !== 6 ? 'flex' : 'none' ,
                              display:
                                getSituation(invoiceItem) === 1 &&
                                !(
                                  showInfoDownloadFile &&
                                  donwloadIdInvoice === invoiceItem.id
                                )
                                  ? 'flex'
                                  : 'none',
                              width: '100%',
                              background:
                                showInfoDownloadFile &&
                                donwloadIdInvoice === invoiceItem.id
                                  ? ''
                                  : '#E6F2CE',
                              height: 50,
                              padding: 10,
                            }}
                          >
                            <div
                              style={{
                                width: '100%',
                                gap: 10,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}
                            >
                              <img
                                src={iconInfoGreen}
                                alt="Infomação"
                                style={{ height: 24 }}
                              />
                              <span
                                style={{
                                  color: '#494949',
                                  fontSize: 11,
                                  lineHeight: '14px',
                                  fontWeight: 400,
                                }}
                              >
                                O pagamento desta fatura foi aprovado e será
                                validado em até 48h úteis.
                              </span>
                            </div>
                          </div>

                          <div
                            style={{
                              color: '#FFFFFF',
                              margin: 'auto',
                              display:
                                showInfoDownloadFile &&
                                donwloadIdInvoice === invoiceItem.id
                                  ? 'block'
                                  : 'none',
                            }}
                          >
                            BAIXANDO FATURA
                          </div>
                        </div>
                      )
                    }
                    return (
                      <div
                        className="InvoiceItem"
                        key={invoiceItem.id}
                        style={{
                          overflow: 'hidden',
                          /* height: 145, */ borderRadius: 8,
                          backgroundColor: 'var(--secondaryColor)',
                          position: 'relative',
                          maxWidth: 283,
                          maxHeight: 160,
                          top: 0,
                          height: 145,
                          marginLeft: 'auto',
                          marginRight: 'auto',
                          width: 283,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <div style={{ color: '#FFFFFF', margin: 'auto' }}>
                          BAIXANDO FATURA
                        </div>
                      </div>
                    )
                  })}
                </S.BoxInvoicesPending>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span
                    style={{
                      fontFamily: 'Inter',
                      color: '#2B2B2B',
                      fontSize: 36,
                      fontWeight: 500,
                      marginTop: 20,
                    }}
                  >
                    Nenhuma fatura encontrada
                  </span>
                  <span
                    style={{
                      fontFamily: 'Inter',
                      color: '#2B2B2B',
                      fontSize: 24,
                      fontWeight: 400,
                    }}
                  >
                    Mude os filtros e tente novamente
                  </span>
                </div>
              )
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  height: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={noInvoicesPendIcon}
                  alt="Todas as faturas foram pagas"
                />
                <span
                  style={{
                    fontFamily: 'Inter',
                    color: '#2B2B2B',
                    fontSize: 36,
                    fontWeight: 500,
                    marginTop: 20,
                  }}
                >
                  Parabéns!!
                </span>
                <span
                  style={{
                    fontFamily: 'Inter',
                    color: '#2B2B2B',
                    fontSize: 24,
                    fontWeight: 400,
                  }}
                >
                  Nenhuma pendencia!
                </span>
              </div>
            )
          ) : (
            // Shimmer Efects
            <img
              src={loadingPrimaryIcon}
              alt="Carregando"
              style={{ height: 140, margin: 0 }}
            />
          )}
          <S.BoxPrice
            style={{
              opacity: totalCart <= 0 ? 0 : 1,
              bottom: totalCart <= 0 ? '0px' : '50px',
              transition: '0.5s ease',
              padding: 10,
              cursor: totalCart <= 0 ? 'default' : '',
              display: 'none',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: 10,
                flexDirection: 'row',
                height: '100%',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  width: 227,
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 8,
                  background: '#EDF1F5',
                }}
              >
                {invoicesId?.length &&
                  `FATURA${invoicesId?.length > 1 ? 'S' : ''} SELECIONADA${
                    invoicesId?.length > 1 ? 'S' : ''
                  } - ${invoicesId?.length}`}
              </span>
              <div
                style={{
                  justifyContent: 'center',
                  borderRadius: 8,
                  display: 'flex',
                  width: 227,
                  height: 40,
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 10,
                  background: '#EDF1F5',
                }}
              >
                {`TOTAL - R$ ${totalCart.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`}
                <img
                  style={{
                    opacity: originalValue !== totalCart ? 1 : 0,
                    display: originalValue !== totalCart ? 'flex' : 'none',
                    transition: 'opacity 0.3s',
                    height: 20,
                  }}
                  data-tip
                  data-for="infoFees"
                  src={iconInfoGreen}
                  alt="Juros e multa"
                />
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                paymentHandle()
              }}
              disabled={totalCart <= 0 || loading}
            >
              {loading ? (
                <img
                  src={loadingIcon}
                  alt="Carregando"
                  style={{ height: 40, margin: 0 }}
                />
              ) : (
                <>
                  <span>INICIAR PAGAMENTO</span>
                  <FontAwesomeIcon icon={faArrowRight} color="#fff" />
                </>
              )}
            </button>
          </S.BoxPrice>

          <S.BoxPriceMobile
            onClick={() => {
              paymentHandle()
            }}
            disabled={totalCart <= 0}
            style={{
              zIndex: totalCart <= 0 ? 10 : 20,
              opacity: totalCart <= 0 ? 0 : 1,
              cursor: totalCart <= 0 ? 'default' : '',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <span>
                {invoicesId?.length
                  ? `${invoicesId?.length} FATURA${
                      invoicesId?.length > 1 ? 'S' : ''
                    }`
                  : ''}
              </span>
              <span style={{ fontSize: 19, fontWeight: 600 }}>
                {`R$ ${totalCart.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`}
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                overflow: 'hidden',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <img
                style={{
                  overflow: 'hidden',
                  opacity: originalValue !== totalCart ? 1 : 0,
                  transition: 'opacity 0.3s',
                }}
                data-tip
                data-for="infoFees"
                src={iconInfoGreen}
                alt="Juros e multa"
              />
              <span style={{ fontSize: 19, fontWeight: 600, marginRight: 10 }}>
                PAGAR
              </span>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 34,
                  width: 34,
                  borderRadius: 8,
                  backgroundColor: '#ECF1DF',
                }}
              >
                {loading ? (
                  <img
                    src={loadingPrimaryIcon}
                    alt="Carregando"
                    style={{ height: 30, margin: 0 }}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    color="var(--primaryColorDark)"
                  />
                )}
              </div>
            </div>
          </S.BoxPriceMobile>
          <PaginationFooterV2WithTotal
            changePage={changePage}
            limit={pageSize}
            loading={loadingData}
            offset={(page - 1) * pageSize}
            page={page}
            hasMore={hasMore}
            total={total}
          >
            <FormlessSelect
              isSearchable={false}
              defaultValue={pageSizes[0]}
              options={pageSizes}
              itemValue={pageSize}
              isDisabled={loadingData}
              name="pageSize"
              label="Páginas"
              onChange={(e) => {
                if (e && e.value !== undefined) {
                  changeMaxPage(e.value)
                }
              }}
            />
          </PaginationFooterV2WithTotal>
        </S.Left>

        <S.Right>
          <S.Title>Pagamento</S.Title>
          <S.TitleMobile>Débitos</S.TitleMobile>
          <S.InputSearchContainerMobile>
            <img alt="search" src={searchIcon} />
            <input
              placeholder="Número da guia"
              value={filterText}
              type="tel"
              onChange={(e) => {
                setFilterText(e.target.value || '')
              }}
            />
          </S.InputSearchContainerMobile>

          <S.BoxAllInvoices>
            {!loadingData ? (
              markedInvoices?.length ? (
                <>
                  <S.InvoiceListHeader>
                    <p>DESCRIÇÃO</p>
                    <p>VALOR (R$)</p>
                  </S.InvoiceListHeader>

                  {markedInvoices.map((invoiceItem) => {
                    return (
                      <S.InvoiceRightItem>
                        <p>{`Guia ${invoiceItem.id}`}</p>
                        <div className="invoice_right_value_container">
                          <p>
                            {`${invoiceItem.totalPaymentDue?.toLocaleString(
                              'pt-BR',
                              { minimumFractionDigits: 2 }
                            )}`}
                          </p>
                          <FontAwesomeIcon
                            onClick={() => {
                              handlePaymentButton(invoiceItem)
                            }}
                            icon={faTrash}
                            color="#CC2E1F"
                          />
                        </div>
                      </S.InvoiceRightItem>
                    )
                  })}
                  <S.BoxInvoicesFooter>
                    <button
                      onClick={() => {
                        paymentHandle()
                      }}
                      type="button"
                      className="invoice_footer_button"
                    >
                      {loading ? (
                        <img
                          src={loadingIcon}
                          alt="Carregando"
                          style={{ height: 40, margin: 0 }}
                        />
                      ) : (
                        <>
                          Pagar{' '}
                          {`R$ ${totalCart.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                          })}`}
                        </>
                      )}
                    </button>

                    <div className="invoice_footer_bill">
                      <p>Fornecido por</p>
                      <img alt="bill" src={logoBill} />
                    </div>
                  </S.BoxInvoicesFooter>
                </>
              ) : (
                <>
                  <S.EmptyInvoice>
                    <img alt="empty" src={emptyInvoiceIcon} />
                    <p>
                      Selecione os débitos ao lado para prosseguir com o
                      pagamento.
                    </p>
                  </S.EmptyInvoice>

                  <S.EmptyInvoiceFooter>
                    <p>Fornecido por</p>
                    <img alt="bill" src={logoBill} />
                  </S.EmptyInvoiceFooter>
                </>
              )
            ) : (
              // Shimmer Efects
              <>
                <div
                  style={{
                    width: '100%',
                    height: 50,
                    background: 'var(--secondaryColor)',
                  }}
                />
                <S.Invoice>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                      padding: '20px 20px 15px 0px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 25,
                              height: 25,
                              borderRadius: '50%',
                              marginRight: 20,
                            }}
                          />
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 80,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                      </div>
                    </div>
                    <S.Skeleton
                      style={{
                        width: 80,
                        height: 25,
                        borderRadius: 16,
                      }}
                    />
                  </div>
                </S.Invoice>
                <S.Invoice>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                      padding: '20px 20px 15px 0px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 25,
                              height: 25,
                              borderRadius: '50%',
                              marginRight: 20,
                            }}
                          />
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 80,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                      </div>
                    </div>
                    <S.Skeleton
                      style={{
                        width: 80,
                        height: 25,
                        borderRadius: 16,
                      }}
                    />
                  </div>
                </S.Invoice>
                <S.Invoice>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                      padding: '20px 20px 15px 0px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 25,
                              height: 25,
                              borderRadius: '50%',
                              marginRight: 20,
                            }}
                          />
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 80,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                      </div>
                    </div>
                    <S.Skeleton
                      style={{
                        width: 80,
                        height: 25,
                        borderRadius: 16,
                      }}
                    />
                  </div>
                </S.Invoice>
                <S.Invoice>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                      padding: '20px 20px 15px 0px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 25,
                              height: 25,
                              borderRadius: '50%',
                              marginRight: 20,
                            }}
                          />
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 120,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                        <span>
                          <S.Skeleton
                            style={{
                              width: 80,
                              height: 10,
                              margin: 5,
                            }}
                          />
                        </span>
                      </div>
                    </div>
                    <S.Skeleton
                      style={{
                        width: 80,
                        height: 25,
                        borderRadius: 16,
                      }}
                    />
                  </div>
                </S.Invoice>
              </>
            )}
          </S.BoxAllInvoices>
          <S.BoxAllInvoicesMobile isTotal={total > 0}>
            {!loadingData ? (
              invoices?.length ? (
                <>
                  {filteredInvoices?.map((invoiceItem, index) => {
                    return (
                      <S.InvoiceItemMobile
                        key={`${invoiceItem.invoice_id}-${index}`}
                        onClick={() => {
                          handlePaymentButton(invoiceItem)
                        }}
                      >
                        <div className="invoice_mobile_column">
                          <S.InvoiceMobileCheck
                            isDisabled={
                              !checkDueDate(invoiceItem.paymentDueDate) ||
                              !checkDueStatus(invoiceItem)
                            }
                            isActive={checkIdList(invoiceItem.invoice_id)}
                          >
                            <FontAwesomeIcon
                              className="mobile_check_icon"
                              icon={faCheck}
                            />
                          </S.InvoiceMobileCheck>
                        </div>
                        <div className="invoice_mobile_container">
                          <div className="invoice_mobile_space-between">
                            <p className="invoice_mobile_label">
                              {invoiceItem.id}
                              {invoiceItem.paymentDueDate
                                ? ` venc. ${
                                    invoiceItem.paymentDueDate
                                      ? transformDate(
                                          invoiceItem.paymentDueDate
                                        )
                                      : ''
                                  }`
                                : ''}
                            </p>
                            <p className="invoice_mobile_label">Valor</p>
                          </div>
                          <div className="invoice_mobile_space-between invoice_mobile_mt-4">
                            {/* <div
                              style={{
                                display: 'grid',
                                maxWidth:'75%'
                              }}
                            >
                              <p className="invoice_mobile_title invoice_mobile_ellipsis">
                                {invoiceDescription(invoiceItem)}
                              </p>
                            </div> */}

                            <p className="invoice_mobile_title invoice_mobile_aling-left">
                              {invoiceDescription(invoiceItem)}
                            </p>

                            <p className="invoice_mobile_title invoice_mobile_aling-right">
                              {`R$ ${invoiceItem.totalPaymentDue?.toLocaleString(
                                'pt-BR',
                                { minimumFractionDigits: 2 }
                              )}`}
                            </p>
                          </div>
                          <div className="invoice_mobile_line invoice_mobile_mt-12" />
                          <div className="invoice_mobile_space-between invoice_mobile_mt-12">
                            <div className="invoice_mobile_row">
                              <S.InvoiceItemStatus
                                color={generatingColorStatus(invoiceItem)}
                              />
                              <p className="invoice_mobile_label">
                                {generatingTextStatus(invoiceItem) || '-'}
                              </p>
                            </div>
                            <S.MobileDetailButton
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setSelectedInvoice(invoiceItem)
                              }}
                            >
                              Ver detalhes
                            </S.MobileDetailButton>
                          </div>
                        </div>
                      </S.InvoiceItemMobile>
                    )
                  })}
                  <PaginationFooterV2WithTotal
                    changePage={changePage}
                    limit={pageSize}
                    loading={loadingData}
                    offset={(page - 1) * pageSize}
                    page={page}
                    hasMore={hasMore}
                    total={total}
                  />
                </>
              ) : (
                <S.EmptyInvoice>
                  <img alt="empty" src={emptyInvoiceIcon} />
                  <p>Nenhuma pendência encontrada</p>
                  <div className="empty_invoice_footer">
                    <p>Fornecido por</p>
                    <img alt="bill" src={logoBill} />
                  </div>
                </S.EmptyInvoice>
              )
            ) : (
              // Shimmer Efects
              <img
                src={loadingPrimaryIcon}
                alt="Carregando"
                style={{ height: 140, margin: 0 }}
              />
            )}
            {/* <div id="mobile">
              <Footer />
            </div> */}
          </S.BoxAllInvoicesMobile>

          <S.BoxPriceMobile
            onClick={() => {
              paymentHandle()
            }}
            disabled={totalCart <= 0}
            style={{
              zIndex: totalCart <= 0 ? 10 : 20,
              opacity: totalCart <= 0 ? 0 : 1,
              cursor: totalCart <= 0 ? 'default' : '',
              bottom: totalCart <= 0 ? -60 : 0,
              // display: totalCart <=0 ? 'none' : 'flex',

              // height: totalCart <=0 ? 0 : 60,
            }}
          >
            <span style={{ fontSize: 19, fontWeight: 600 }}>
              {`Total R$ ${totalCart.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`}
            </span>
            {
              <div className="box_price_mobile_continue">
                {loading ? (
                  <img
                    src={loadingPrimaryIcon}
                    alt="Carregando"
                    style={{ height: 30, margin: 0 }}
                  />
                ) : (
                  <>
                    {' '}
                    <span>Continuar</span>
                    <FontAwesomeIcon icon={faArrowRight} color="#212121" />
                  </>
                )}
                {/* <img
                style={{
                  overflow: 'hidden',
                  opacity: originalValue !== totalCart ? 1 : 0,
                  transition: 'opacity 0.3s',
                }}
                data-tip
                data-for="infoFees"
                src={iconInfoGreen}
                alt="Juros e multa"
              /> */}
              </div>
            }
          </S.BoxPriceMobile>
        </S.Right>
      </S.Box>
      <ReactTooltip
        id="infoFees"
        disable={originalValue === totalCart}
        place="top"
        type="dark"
        effect="solid"
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
            alignItems: 'flex-start',
          }}
        >
          <h3>
            Valor original:
            <span>
              {` R$ ${originalValue.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`}
            </span>
          </h3>
          <span>Devido ao atraso, serão cobrados:</span>
          <h4>
            {`Juros: R$ ${fees.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`}
          </h4>
          <h4>
            {`Multas: R$ ${penalty.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`}
          </h4>
          <h4>
            {`Correção: R$ ${correction.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`}
          </h4>
          <h3>
            Valor Atualizado:
            <span>
              {` R$ ${totalCart.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`}
            </span>
          </h3>
        </div>
      </ReactTooltip>
    </S.Container>
  )
}

export default connect((state: StateInitial) => ({ modules: state }))(Home)
